import { httpService } from '../common/http.service';
import type { ApiResponse } from '../common/types/api-response';
import type { PrivacyConsents, UpdatePrivacyConsentsPayload } from './types/privacy-consents';

/** Stores the signed-in user's choices; the server records each change in its audit history. */
export async function updatePrivacyConsents(payload: UpdatePrivacyConsentsPayload) {
  const res = await httpService.put<ApiResponse<PrivacyConsents>>('user/privacy-consents', payload);
  return res.data.data;
}
